import type { GlucoseAverageReadingWakeUpInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { WakeUpFillIcon } from "@tandemdiabetes/sugarmate-react-components"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./Tile.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import {
  useDisplayGlucoseValue,
  useReadableGlucoseUnit,
} from "src/hooks"

export function GlucoseAverageReadingWakeUp(props: TileProps<GlucoseAverageReadingWakeUpInsight>) {
  const {
    insightKey,
    range,
  } = props

  const displayGlucoseValue = useDisplayGlucoseValue()
  const glucoseUnit = useReadableGlucoseUnit()

  const { glucoseCalculations } = useCalculationsContext()
  const { wakeUpAverage } = glucoseCalculations[range] || {}

  const value = (isNaN(wakeUpAverage) || wakeUpAverage === undefined)
    ? "--"
    : displayGlucoseValue(wakeUpAverage)

  return (
    <>
      <TileTitle insightKey={insightKey}>
        <WakeUpFillIcon className={styles.titleIcon} />
      </TileTitle>
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {glucoseUnit}
      </TileUnit>
    </>
  )
}
